if (!customElements.get('wholesale-price')) {
    customElements.define(
        'wholesale-price',
        class wholesalePrice extends HTMLElement {
            constructor() {
                super();
                this.oneTimePrice = this.querySelector('.one-time__price')
                this.oneTimeCompare = this.querySelector('.one-time__compare')
                this.variants = document.querySelectorAll('input[type=radio].variant-option')
                
                this.attachEvents()
            }

            /* The `attachEvents` function is a method defined within the `wholesalePrice` class. It
            uses arrow function syntax to define the function. This function iterates over each
            element in the `variants` NodeList (which contains all radio input elements with the
            class `variant-option`) using the `forEach` method. */
            attachEvents = () => {
                this.variants.forEach(variant => {
                    variant.addEventListener('change', this.variantChange)
                })
            }

            /* The `variantChange` function is an arrow function that is handling the change event for
            radio input elements with the class `variant-option`. When a radio input is changed,
            this function is triggered with the event object `e`. */
            variantChange = (e) => {
                if(e.target.dataset.price !== undefined) {
                    this.oneTimePrice.innerText = e.target.dataset.price
                } else {
                    this.oneTimePrice.innerText = ''
                }

                if(e.target.dataset.compareAtPrice !== undefined) {
                    this.oneTimeCompare.innerText = e.target.dataset.compareAtPrice
                } else {
                    this.oneTimeCompare.innerText = ''
                }
            }
        }
    );
}